import { render } from "./HR_Department_Dialog.vue?vue&type=template&id=fb93067c&scoped=true&ts=true"
import script from "./HR_Department_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_Department_Dialog.vue?vue&type=script&lang=ts"

import "./HR_Department_Dialog.vue?vue&type=style&index=0&id=fb93067c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb93067c"]])

export default __exports__